import React from 'react';
import { DOWNLOAD_PATH } from '../../../utils';

export function ProcessHype() {
    return (
        <section className="py-0 hero" style={{ marginBottom: '-0.5rem' }}>
            <iframe
                className="process-hype"
                src={`${DOWNLOAD_PATH}/hype_animation/process_hype_23.html`}
                title="Laser hair removal process"
            ></iframe>
        </section>
    );
}

export default ProcessHype;
